/**
 * Returns the group and decimal separators used by the given locale
 * (e.g. { group: ".", decimal: "," } for nl-NL).
 */
export const getLocaleSeparators = (
	locale: string
): { group: string; decimal: string } => {
	const parts = new Intl.NumberFormat(locale).formatToParts(12345.6);

	return {
		group: parts.find((part) => part.type === "group")?.value ?? ",",
		decimal: parts.find((part) => part.type === "decimal")?.value ?? ".",
	};
};

/**
 * Parses a number string that was formatted for the given locale
 * (e.g. "1.234,56" for nl-NL or "1,234.56" for en-US) back into a number.
 * Currency symbols, unit suffixes and whitespace are ignored.
 */
export const parseLocaleNumber = (value: string, locale: string): number => {
	const { group, decimal } = getLocaleSeparators(locale);

	const normalized = value
		.replace(/\s/g, "")
		.replaceAll(group, "")
		.replace(decimal, ".")
		.replace(/[^0-9.-]+/g, "");

	return parseFloat(normalized);
};
